
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Lightbulb, Flame, Droplet } from 'lucide-react';
import NavigationItem from './NavigationItem';
import NavSection from './NavSection';
import CommonDropdownItems from './CommonDropdownItems';

const Navigation = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  // Improved active link detection
  const isActiveSection = (section: string) => {
    return currentPath.startsWith(`/${section}`);
  };

  return (
    <nav className="hidden md:flex items-center space-x-6">
      <NavigationItem to="/dashboard" currentPath={currentPath}>
        <span className="font-medium text-gray-800 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
          Dashboard
        </span>
      </NavigationItem>

      {/* Energy Dropdown */}
      <NavSection 
        icon={<Lightbulb className="text-energy-blue" />}
        label="Energy"
        isActive={isActiveSection("energy")}
        labelColor="text-energy-blue dark:text-energy-lightBlue"
      >
        <CommonDropdownItems basePath="energy" currentPath={currentPath} />
      </NavSection>

      {/* Gas Dropdown */}
      <NavSection 
        icon={<Flame className="text-amber-600" />}
        label="Gas"
        isActive={isActiveSection("gas")}
        labelColor="text-amber-600 dark:text-amber-400"
      >
        <CommonDropdownItems basePath="gas" currentPath={currentPath} />
      </NavSection>

      {/* Water Dropdown */}
      <NavSection 
        icon={<Droplet className="text-cyan-600" />}
        label="Water"
        isActive={isActiveSection("water")}
        labelColor="text-cyan-600 dark:text-cyan-400"
      >
        <CommonDropdownItems basePath="water" currentPath={currentPath} />
      </NavSection>
    </nav>
  );
};

export default Navigation;
